import React, { useState } from "react";

// Drop-in replacement for <input type="password">, used everywhere a
// password or PIN is entered — masked characters are easy to mistype and
// impossible to proof-read, so every one of these fields gets a toggle to
// reveal what was actually typed before submitting.
export default function PasswordInput({ className, style, wrapperStyle, ...props }) {
  const [show, setShow] = useState(false);

  return (
    <div style={{ position: "relative", ...wrapperStyle }}>
      <input
        {...props}
        type={show ? "text" : "password"}
        className={className}
        style={{ ...style, paddingRight: "38px" }}
      />
      <button
        type="button"
        onClick={() => setShow(s => !s)}
        tabIndex={-1}
        aria-label={show ? "Hide password" : "Show password"}
        style={{
          position: "absolute", right: "10px", top: "50%", transform: "translateY(-50%)",
          background: "none", border: "none", cursor: "pointer", padding: "2px",
          fontSize: "16px", lineHeight: 1, color: "#6b7280"
        }}
      >
        {show ? "🙈" : "👁️"}
      </button>
    </div>
  );
}
